import React, { useState } from "react";
import api from "../../Utils/api";
import { toast } from "react-toastify";
import Spinner from "../Spinner";

const PublishShiftsDialog = ({
  schedules,
  selectedDate,
  period,
  getSchedules,
}) => {
  const [open, setOpen] = useState(false);

  const [step, setStep] = useState(0);
  const [publishType, setPublishType] = useState("updates");
  const [workAreas, setWorkAreas] = useState(["Guard"]);
  const [notifyType, setNotifyType] = useState("email");
  const [isLoading, setIsLoading] = useState(false);

  // For demonstration, we only have one area: "Guard"
  const allWorkAreas = ["Guard"];

  function handleNext() {
    setStep((s) => s + 1);
  }

  function handleBack() {
    if (step === 0) {
      closePublishDialog();
    } else {
      setStep((s) => s - 1);
    }
  }

  const closePublishDialog = () => {
    setStep(0);
    setOpen(false);
  };

  const publishShifts = async () => {
    const start = new Date(selectedDate); // selectedDate should be a Date object
    start.setUTCHours(0, 0, 0, 0); // Set to 00:00:00.000

    const end = new Date(start); // clone the start date
    end.setDate(end.getDate() + period - 1); // add (period - 1) days to include start date
    end.setUTCHours(23, 59, 59, 999); // Set to 23:59:59.999
    setIsLoading(true);
    const res = await api.post(`/schedule/publish`, {
      startTime: start.toISOString(), // full ISO with time
      endTime: end.toISOString(), // full ISO with time
      admin: true,
      type: notifyType,
    });
    setIsLoading(false);

    if (res.data.success) {
      toast.success(res.data.message);

      getSchedules();
      closePublishDialog();
    } else {
      toast.error("Failed to delete!");
    }
  };

  function compareDate(date1, date2) {
    const d1 = new Date(date1);
    const d2 = new Date(date2);

    if (d1 > d2) return true; // date1 is after date2
    if (d1 < d2) return false; // date1 is before date2
    return 0; // dates are equal
  }

  return (
    <>
      {isLoading && <Spinner />}
      {open && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
          <div className="bg-white rounded-lg shadow-lg w-full max-w-md flex flex-col relative max-h-[90vh]">
            {/* Close button */}
            <button
              className="absolute top-2 right-2 text-gray-400 hover:text-gray-600"
              onClick={closePublishDialog}
            >
              ×
            </button>

            {/* Stepper */}
            <div className="flex items-center mb-6 space-x-2 p-6 pb-0">
              {[0, 1, 2].map((idx) => (
                <span
                  key={idx}
                  className={`w-4 h-4 rounded-full border-2 flex items-center justify-center text-white text-xs font-bold ${
                    step > idx
                      ? "bg-green-500 border-green-500"
                      : step === idx
                      ? "bg-green-400 border-green-400"
                      : "bg-white border-gray-300 text-transparent"
                  }`}
                >
                  {step > idx ? <i className="fa fa-check" /> : ""}
                </span>
              ))}
            </div>

            <div className="flex-1 overflow-y-auto p-6 pt-0">
              {/* Step 0: Publish type */}
              {step === 0 && (
                <div className="h-[40vh]">
                  <h2 className="text-xl font-semibold mb-2">Publish type</h2>
                  <p className="text-gray-600 mb-4">
                    Team member's can only see shifts you publish. You can send
                    employees a list of their published shifts via email, sms
                    and/or smartphone apps or choose not to notify them.
                  </p>
                  <div className="space-y-2 mb-6">
                    <label
                      className={`flex items-center p-3 rounded-md cursor-pointer border ${
                        publishType === "updates"
                          ? "bg-blue-50 border-blue-500"
                          : "border-gray-200"
                      }`}
                    >
                      <input
                        type="radio"
                        className="mr-3"
                        checked={publishType === "updates"}
                        onChange={() => setPublishType("updates")}
                      />
                      <span>
                        <span className="font-medium">Publish updates</span>
                        <br />
                        <span className="text-gray-500 text-sm">
                          Only Team members whose shifts have changed will be
                          notified.
                        </span>
                      </span>
                    </label>
                    {/* <label
                      className={`flex items-center p-3 rounded-md cursor-pointer border ${
                        publishType === "all"
                          ? "bg-blue-50 border-blue-500"
                          : "border-gray-200"
                      }`}
                    >
                      <input
                        type="radio"
                        className="mr-3"
                        checked={publishType === "all"}
                        onChange={() => setPublishType("all")}
                      />
                      <span>
                        <span className="font-medium">Publish all</span>
                        <br />
                        <span className="text-gray-500 text-sm">
                          All Team members with shifts will be notified.
                        </span>
                      </span>
                    </label> */}
                  </div>
                </div>
              )}

              {/* Step 1: Choose work areas */}
              {/* {step === 1 && (
                <div className="h-[40vh]">
                  <h2 className="text-xl font-semibold mb-2">
                    Choose work areas
                  </h2>
                  <p className="text-gray-600 mb-4">
                    You can publish shifts for just one work area or multiple at
                    once.
                  </p>
                  <div className="mb-4">
                    <span
                      className="text-blue-600 text-sm cursor-pointer mr-2"
                      onClick={() => setWorkAreas(allWorkAreas)}
                    >
                      all
                    </span>
                    <span
                      className="text-blue-600 text-sm cursor-pointer mr-2"
                      onClick={() => setWorkAreas([])}
                    >
                      none
                    </span>
                    <span
                      className="text-blue-600 text-sm cursor-pointer"
                      onClick={() =>
                        setWorkAreas(
                          allWorkAreas
                            .filter((area) => !workAreas.includes(area))
                            .concat(
                              workAreas.filter(
                                (area) => !allWorkAreas.includes(area)
                              )
                            )
                        )
                      }
                    >
                      inverse
                    </span>
                  </div>
                  <div className="mb-6">
                    {allWorkAreas.map((area) => (
                      <label key={area} className="flex items-center mb-2">
                        <input
                          type="checkbox"
                          className="mr-2"
                          checked={workAreas.includes(area)}
                          onChange={() =>
                            setWorkAreas((prev) =>
                              prev.includes(area)
                                ? prev.filter((a) => a !== area)
                                : [...prev, area]
                            )
                          }
                        />
                        {area}
                      </label>
                    ))}
                  </div>
                </div>
              )} */}

              {/* Step 2: Notify staff */}
              {step === 1 && (
                <div className="h-[40vh]">
                  <h2 className="text-xl font-semibold mb-2">Notify staff</h2>
                  <p className="text-gray-600 mb-4">
                    You can choose to send staff their schedules .
                  </p>
                  <div className="space-y-2 mb-6">
                    <label
                      className={`flex items-center p-3 rounded-md cursor-pointer border ${
                        notifyType === "email"
                          ? "bg-blue-50 border-blue-500"
                          : "border-gray-200"
                      }`}
                    >
                      <input
                        type="radio"
                        className="mr-3"
                        checked={notifyType === "email"}
                        onChange={() => setNotifyType("email")}
                      />
                      Notify (app)
                    </label>
                    {/* <label
                      className={`flex items-center p-3 rounded-md cursor-pointer border ${
                        notifyType === "confirm"
                          ? "bg-blue-50 border-blue-500"
                          : "border-gray-200"
                      }`}
                    >
                      <input
                        type="radio"
                        className="mr-3"
                        disabled
                        checked={notifyType === "confirm"}
                        onChange={() => setNotifyType("confirm")}
                      />
                      Require confirmation (email and app)
                    </label> */}
                    {/* <label
                      className={`flex items-center p-3 rounded-md cursor-pointer border ${
                        notifyType === "none"
                          ? "bg-blue-50 border-blue-500"
                          : "border-gray-200"
                      }`}
                    >
                      <input
                        type="radio"
                        className="mr-3"
                        checked={notifyType === "none"}
                        onChange={() => setNotifyType("none")}
                      />
                      No notifications (mark as published)
                    </label> */}
                  </div>
                </div>
              )}

              {/* Step 3: Publishing progress */}
              {step === 2 && (
                <div className="h-[40vh]">
                  <h2 className="text-xl font-semibold mb-4">
                    Publishing shifts
                  </h2>
                  <ul className="space-y-2">
                    <li className="flex items-center">
                      <span className="w-3 h-3 rounded-full bg-gray-300 mr-2 inline-block" />
                      Checking shifts for issues
                    </li>
                    <li className="flex items-center">
                      <span className="w-3 h-3 rounded-full bg-gray-300 mr-2 inline-block" />
                      Preparing open shifts
                    </li>
                    <li className="flex items-center">
                      <span className="w-3 h-3 rounded-full bg-gray-300 mr-2 inline-block" />
                      Publishing shifts
                    </li>
                  </ul>
                </div>
              )}
            </div>

            {/* Action buttons fixed at bottom */}
            <div className="border-t px-6 py-4 bg-white flex justify-between sticky bottom-0 left-0 right-0 z-10">
              {/* Hide actions on progress step */}
              {step < 3 && (
                <>
                  <button
                    className="px-5 py-2 rounded-md bg-gray-100"
                    onClick={handleBack}
                  >
                    {step === 0 ? "Cancel" : "Back"}
                  </button>
                  {step === 2 ? (
                    <button
                      className="bg-purple-700 text-white px-5 py-2 rounded-md hover:bg-purple-800"
                      onClick={publishShifts}
                    >
                      Publish
                    </button>
                  ) : (
                    <button
                      className="bg-purple-700 text-white px-5 py-2 rounded-md hover:bg-purple-800"
                      onClick={handleNext}
                      disabled={step === 1 && workAreas.length === 0}
                    >
                      Next
                    </button>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      )}
      {schedules.filter(
        (item) => !item.published && compareDate(item.startTime, selectedDate)
      ).length > 0 && (
        <button
          className="py-2 px-2 bg-gray-600 hover:bg-gray-800 rounded-md text-white"
          onClick={() => setOpen(true)}
        >
          {schedules.filter(
            (item) =>
              !item.published && compareDate(item.startTime, selectedDate)
          ).length > 0
            ? `Publish ${
                schedules.filter(
                  (item) =>
                    !item.published && compareDate(item.startTime, selectedDate)
                ).length
              } shifts`
            : "All Schedule Published"}{" "}
        </button>
      )}
    </>
  );
};

export default PublishShiftsDialog;
